module.exports = __webpack_public_path__ + "images/1f68391be4c891192eb832b7cbd17e12900256980cdd7b17d076c8cfc41c0ba5.svg";